export const QUERY_KEYS = {
  chatMessages: (chatId?: string) => ["chat", "messages", chatId] as const,
  chatMetadata: () => ["chat", "metadata"] as const,
  chatHistory: () => ["chat", "history"] as const,
} as const;

export const ROUTES = {
  CHAT_ROOT: "/maite-v2",
  CHAT_WITH_ID: (chatId: string) => `/maite-v2/${chatId}`,
} as const;

export const UI_CONSTANTS = {
  MIN_QUESTION_LENGTH: 3,
  TEXTAREA_ROWS: 2,
} as const;
